const getters = {
  // sidebar: state => state.app.sidebar,
  // device: state => state.app.device,
  // language: state => state.app.language,
  // token: state => state.user,
  // sld: state => state.user.sld,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // roles: state => state.user.roles,
  // students: state => state.user.students,
  // student: state => state.user.student,
  // portrait: state => state.user.portrait,
  // studentId: state => state.user.studentId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js